import { Match } from "../types/Match";

/**
 * Human-readable venue label built from the match's API stadium fields,
 * e.g. "MetLife Stadium · East Rutherford". Returns an empty string when the
 * venue isn't known yet (e.g. TBD knockout fixtures), so callers can hide the
 * row instead of showing a placeholder.
 */
export const matchVenueLabel = (match: Match): string =>
  [match.stadiumName, match.stadiumCity].filter(Boolean).join(" · ");
